import CustomSelectAdvanced from '../CustomSelectAdvanced/CustomSelectAdvanced'
import './ConfigEditarChamado.css'
import { useContext, useEffect, useState } from 'react';
import { EditTicketContext } from '../../context/EditTicketContext';
import HeaderContainers from '../HeaderContainers/HeaderContainers';
import { getStatus } from '../../services/statusService';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import NotifyUtils from '../../utils/NotifyUtils';
import { useTranslation } from 'react-i18next';

function ConfigEditarChamado() {

    const { t } = useTranslation();
    const { ticketData, 
        handleCancelling, 
        usuariosDisponiveis, 
        departamentosDisponiveis, 
        handleChange, 
        handleSubmit, 
        podeEditarEsseChamado} = useContext(EditTicketContext);

    const [status, setStatus] = useState(null);

    const textoConfirmar = t("confirmar-edicao");
    const textoCarregando = t("texto-carregando");
    const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
    const [mensagemBotaoConfirmar, setMensagemBotaoConfirmar] = useState(textoConfirmar);
    const [podeEscolher, setPodeEscolher] = useState(true);

    useEffect(() => {
        getStatus().then((status) => {
            setStatus(status.sort((a, b) => a.ordem - b.ordem));
        }).catch((error) => {
            console.error(error);
        });
    }, []);

    const [departamentoEmpresas, setDepartamentoEmpresas] = useState(departamentosDisponiveis);
    useEffect(() => {
        setDepartamentoEmpresas(departamentosDisponiveis);
    }, [departamentosDisponiveis]);

    const [usuarios, setUsuarios] = useState(usuariosDisponiveis);
    useEffect(() => {
        setUsuarios(usuariosDisponiveis);
    }, [usuariosDisponiveis]);

    let estadosChamados = [];
    let usuariosResponsaveis = [];
    let departamentos = [];
    
    if (status !== null) {
        estadosChamados = status;
    } else {
        return <div>Loading...</div>;
    }

    if(usuarios !== null) {
        usuariosResponsaveis = usuarios;
    } else {
        return <div>Loading...</div>;
    }

    if(departamentoEmpresas !== null) {
        departamentos = departamentoEmpresas;
    } else {
        return <div>Loading...</div>;
    }

    if(ticketData === null) {
        return <div>Loading...</div>;
    }

    const clickBotaoConfirmar = async (e) => {
        // Assim que confirmar, desabilita o botão e muda o texto para "carregando..."
        e.preventDefault();
        setBotaoDesabilitado(true);
        setMensagemBotaoConfirmar(textoCarregando);

        // Faz o envio de informações para o back caso esteja tudo certo com os campos, se não tiver, retorna os campos inválidos
        const retornoRequest = await handleSubmit();

        if(retornoRequest === null) {
            NotifyUtils.info(t("sem-alteracao"));
            setPodeEscolher(true);
            return;
        }

        const erroCustom = retornoRequest.success === undefined;
    
        if(!retornoRequest.success && !erroCustom) {
            NotifyUtils.erro(retornoRequest.message);
        } else if(retornoRequest.success) {
            NotifyUtils.sucesso(retornoRequest.message);

            setTimeout(() => {
                setBotaoDesabilitado(false);
                setMensagemBotaoConfirmar(textoConfirmar);
                setPodeEscolher(true);
            }, 2500);
            return;
        } else if(erroCustom) {
            NotifyUtils.erro(retornoRequest.message);
        }

        setPodeEscolher(true);
        setBotaoDesabilitado(false);
        setMensagemBotaoConfirmar(textoConfirmar);
    };

    return (
        <div className="configuracoes-chamado-container">
            <HeaderContainers texto={t("configuracao-chamados")} />
            <div className="container-selects-configuracao">

                <CustomSelectAdvanced
                    required={true}
                    tipoSelect={"status"}
                    opcoes={estadosChamados}
                    titulo={t("estado-chamado")}
                    handleChange={handleChange}
                    extra={estadosChamados}
                    tipoExtra={"status"}
                    opcaoInicial={true}
                    defaultOption={ticketData.status ? t("status-" +ticketData.status.idStatus) : undefined}
                    naoAtualiza={true}
                    podeEscolher={podeEscolher && podeEditarEsseChamado}
                />

                <CustomSelectAdvanced
                    required={true}
                    tipoSelect={"departamentoEmpresa"}
                    opcoes={separaDepartamentoEmpresa(departamentos)}
                    titulo={t("departamento")}
                    handleChange={handleChange}
                    extra={departamentos}
                    tipoExtra={"departamento"}
                    opcaoInicial={true}
                    defaultOption={ticketData.departamentoEmpresa ? ticketData.departamentoEmpresa.departamento.nomeDepartamento : undefined}
                    podeEscolher={podeEscolher && podeEditarEsseChamado}
                />

                <CustomSelectAdvanced
                    required={true}
                    tipoSelect={"usuarioResponsavelAtual"}
                    opcoes={separaUsuario(usuariosResponsaveis)}
                    titulo={t("usuario-responsavel")}
                    handleChange={handleChange}
                    tipoExtra={"usuario"}
                    extra={usuariosResponsaveis}
                    opcaoInicial={true}
                    defaultOption={ticketData.usuarioResponsavelAtual ? ticketData.usuarioResponsavelAtual.nome : undefined}
                    podeEscolher={podeEscolher && podeEditarEsseChamado}
                />

            </div>

            <div className="botoes-config-container">
                <BotaoPadrao
                    acaoDeClicar={handleCancelling}
                    texto={t("botao-cancelar")}
                    cancelar={true}
                />
                <BotaoPadrao
                    acaoDeClicar={clickBotaoConfirmar}
                    texto={mensagemBotaoConfirmar}
                    confirmar={true}
                    disabled={!podeEditarEsseChamado || !podeEscolher || botaoDesabilitado}
                />
            </div>

        </div>
    );
}

const separaDepartamentoEmpresa = (listaDepartamentoEmpresa) => {
    let departamentos = [];

    if(listaDepartamentoEmpresa === undefined) {
        return departamentos;
    }

    for (let index = 0; index < listaDepartamentoEmpresa.length; index++) {
        const departamentoEmpresa = listaDepartamentoEmpresa[index];
        departamentos.push({ 
            descricao: departamentoEmpresa.departamento.nomeDepartamento,
            identificador: departamentoEmpresa.idDepartamentoEmpresa});
    }

    return departamentos;
}

const separaUsuario = (listaUsuarios) => {
    let usuarios = [];

    if(listaUsuarios === undefined) {
        return usuarios;
    }

    for (let index = 0; index < listaUsuarios.length; index++) {
        const usuario = listaUsuarios[index];
        usuarios.push({ 
            descricao: usuario.nome,
            identificador: usuario.idUsuario});
    }

    return usuarios;
}

export default ConfigEditarChamado;